<template>
    <div class="tiktok-form">
        <h1>{{ data.name.charAt(0).toUpperCase() + data.name.slice(1) }}<span class="purple-text">.</span></h1>


        <div class="white-box-wrap" id="top-error-point">
            <span class="white-box"><img :src="'/img/logos/' + data.icon_color"/></span>
        </div>

        <div class="enter-nick">
            <div class="form-group">
                <input-group v-model="form.url" :val="form.url" name="url" :placeholder="data.text_url" :valid="(errors.url && errors.urlFormat)" :showErrors="showErrors" class="big ta-l">
                    <template v-slot:errorMessage>Podaj swój nick</template>
                </input-group>

                <input-group v-model="form.score" :val="form.score" name="score" :placeholder="data.text_subscribers" class="score ta-l" :valid="errors.score" :showErrors="showErrors" pattern="\d*">
                    <template v-slot:errorMessage>Podaj swój nick</template>
                </input-group>
            </div>
        </div>

        <div class="add-screen" id="upload-error-point">
            <h3>Dodaj screen</h3>
            <p>panelu swojego profilu</p>

            <form-error :show="!errors.uploadError && showErrors" className="upload-error">
                <template v-slot:errorMessage>
                    Dodaj poprawny screen
                </template>
            </form-error>

            <div class="upload">

                <file-upload
                        ref="upload"
                        accept="image/*"
                        v-model="files"
                        :post-action="postImageUrl"
                        @input-file="inputFile"
                        @input-filter="inputFilter" >
                    <div v-if="files.length === 0" class="image-upload-wrap">
                        <img class="add-button" src="../../../assets/add_button.png" />
                    </div>
                </file-upload>

                <div v-if="$refs.upload && !$refs.upload.active" class="uploaded-image" v-for="(file, index) in files" :key="file.id">
                    <img v-if="file.thumb" :src="file.thumb" width="40" height="auto" />
                </div>

                <Loader v-if="$refs.upload && $refs.upload.active" />

                <div v-if="$refs.upload && !$refs.upload.active && files.length" class="navigation upload-navigation">
                    <button v-if="!uploaded" @click="$refs.upload.active = true" type="button" class="submit-purple-button">Wyślij</button>
                    <button v-if="uploaded" @click="resetUploadForm" type="button" class="submit-purple-button">Usuń</button>
                </div>

            </div>

            <p class="show-image-trigger" @click="previewHidden = !previewHidden">Zobacz o który ekran chodzi</p>
        </div>

        <div class="clearfix"></div>

        <img :class="'screen ' + (previewHidden ? 'hidden' : '')" src="../../../assets/tiktok_screenshot.png" />

        <h4 id="bottom-error-point">Zasady współpracy</h4>

        <div class="barter-buttons">
            <icon-text-checkbox :nolabel="true" v-model="form.isBarter" :value="form.isBarter">
                <template v-slot:image>
                    <img src="../../../assets/barter_icon.png" />
                </template>
            </icon-text-checkbox>

            <icon-text-input-checkbox :nolabel="true" v-model="form.isPaid" :value="form.isPaid" :value-income="form.income" v-on:income="incomeChange">
                <template v-slot:image>
                    <img src="../../../assets/cash_icon.png" />
                </template>
            </icon-text-input-checkbox>
        </div>

        <form-error :show="!errors.barter && showErrors" className="barter-error">
            <template v-slot:errorMessage>
                Wybierz zasadę współpracy
            </template>
        </form-error>

        <form-error :show="!errors.income && showErrors" className="income-error">
            <template v-slot:errorMessage>
                Uzupełnij wynagrodzenie
            </template>
        </form-error>

        <div class="income-form">
            <span v-if="form.isBarter && !form.isPaid" class="income-label">Współpraca barterowa</span>
            <span v-if="!form.isBarter && form.isPaid" class="income-label">Tylko płatne wpisy</span>
            <span v-if="form.isBarter && form.isPaid" class="income-label">Współpraca barterowa lub płatna</span>
        </div>


        <div class="navigation next-navigation">
            <button v-on:click="handleNextStep" type="button" class="submit-purple-button">Dalej</button>
        </div>

        <floating-navigation>
            <button v-on:click="$emit('go-back')" type="button" class="go-back-button"></button>
            <button v-on:click="$emit('cancel-step')" class="clear-right-button">pomiń {{data.name}}</button>
        </floating-navigation>

    </div>
</template>

<script>
    import InputGroup from "../elements/InputGroup";
    import Loader from "../../Loader";
    import Router from "../../../routing";
    import IconTextCheckbox from "../elements/IconTextCheckbox";
    import IconTextInputCheckbox from "../elements/IconTextInputCheckbox";
    import FormError from "../elements/FormError";
    import FileUpload from 'vue-upload-component';
    import SmoothScroll from 'smooth-scroll';
    import Spacer from "../../Spacer";
    import FloatingNavigation from "../elements/floatingNavigation";


    export default {
        name: "SocialTikTok",
        components: {
            FloatingNavigation,
            Spacer, FormError, IconTextInputCheckbox, IconTextCheckbox, Loader, InputGroup, FileUpload},
        props: ["data", "value", "index", "user"],
        mounted() {
            this.form = this.value;
            if(this.form.file) {
                this.files = [this.form.file];
                this.uploaded = true;
            }
        },
        async updated() {
            await this.$nextTick();
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent .initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        },
        data() {
            return {
                nick: '',
                showErrors: false,
                hash: '',
                uploaded: false,
                files: [],
                postImageUrl: Router.generate('tiktok_upload'),
                previewHidden: true,
                form: {
                    valid: true,
                    url: "",
                    score: "",
                    isBarter: false,
                    isPaid: false,
                    income: ""
                },
                errors: {
                    url: true,
                    urlFormat: true,
                    score: true,
                    barter: true,
                    income: true,
                    uploadError: true
                }
            };
        },
        watch: {
            form: {
                handler(val) {
                    this.$emit('input', val);
                },
                deep: true
            },
            value: {
                handler(val) {
                    this.form = val;
                },
                deep: true
            },
            index: function () {
                this.form = this.value;
                this.resetErrors();
            }
        },
        methods: {
            handleNextStep() {
                let errorPoint = this.validate();

                if(this.isValid()) {
                    this.showErrors = false;
                    this.$emit('next-step');
                }
                else {
                    let scroll = new SmoothScroll();
                    let anchor = document.getElementById(errorPoint);

                    scroll.animateScroll(anchor, null, {updateURL: false});

                    this.$notify({
                        group: 'form',
                        type: 'warn',
                        title: 'Formularz zawiera błędy'
                    });

                    this.showErrors = true;
                }
            },
            resetUploadForm: function() {
                this.$refs.upload.clear();
                this.uploaded = false;
            },
            incomeChange: function(income) {
                this.form.income = income;
            },
            validate: function () {

                let errorPoint = 'bottom-error-point';

                this.errors.barter = (this.form.isPaid || this.form.isBarter);
                this.errors.income = (!this.form.isPaid || this.form.income && ((this.form.isPaid && (this.form.income.length))));


                this.errors.url = !(this.form.url.length === 0);

                if(this.errors.url && this.data.regex) {
                    let regex = RegExp(this.data.regex, 'i');
                    this.errors.urlFormat = regex.test(this.form.url);
                }

                this.errors.score = !(this.form.score.length === 0);

                this.errors.uploadError = this.uploaded;

                if(!this.errors.url || !this.errors.score || !this.errors.uploadError) errorPoint = 'top-error-point';

                this.form.valid = this.isValid();

                return errorPoint;
            },
            isValid() {
                if(!this.errors.url) return false;
                if(!this.errors.urlFormat) return false;
                if(!this.errors.score) return false;
                if(!this.errors.barter) return false;
                if(!this.errors.income) return false;
                if(!this.errors.uploadError) return false;

                return true;
            },
            resetErrors() {
                this.errors = {
                    url: true,
                    urlFormat: true,
                    score: true,
                    barter: true,
                    income: true,
                    uploadError: true
                };
            },

            inputFile: function (newFile, oldFile) {
                if(!this.$refs.upload.active && newFile && !newFile.success) {
                    this.$refs.upload.active = true;
                }
            },

            inputFilter: function (newFile, oldFile, prevent) {

                if(newFile) {
                    this.uploaded = newFile.success;

                    if(this.uploaded) {
                        this.form.file = newFile;
                    }

                    if(newFile.error) {
                        this.$notify({
                            group: 'form',
                            type: 'warn',
                            title: 'Wystąpił błąd'
                        });

                        this.form.file = false;

                        this.resetUploadForm();
                    }
                }

                if (newFile && !oldFile) {
                    // Filter non-image file
                    if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }

                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }

                // Thumbnails
                // 缩略图
                newFile.thumb = ''
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                }

                let headers = Router.getAuthHeader();

                newFile.headers['X-AUTH-TOKEN'] = headers.headers['X-AUTH-TOKEN'];
            }
        },
        watch: {
            form: {
                handler(val) {
                    this.validate();
                    this.$emit('input', val);
                },
                deep: true
            },

            value: {
                handler(val) {
                    this.form = val;
                },
                deep: true
            },

            index: function () {
                this.form = this.value;
                this.resetErrors();
                this.validate();
            }
        }
    }
</script>

<style scoped lang="scss">

</style>